import services from 'api/services';
import { ObjectException, logError } from 'global/errors';
import { isValidEmail } from 'functions/stringValidation';

import { login } from 'global/actions/authActions';
import {
  MANAGE_PASSWORD_REQUEST,
  MANAGE_PASSWORD_SUCCESS,
  MANAGE_PASSWORD_FAILURE,
  UPDATE_PASSWORD_REQUEST,
  UPDATE_PASSWORD_SUCCESS,
  UPDATE_PASSWORD_FAILURE,
  MANAGE_PASSWORD_CLEAR_ERROR,
  MANAGE_PASSWORD_CLEAR_STATE,
} from '../constants';

const { AuthService } = services;

export const clearState = () => (dispatch) => {
  dispatch({ type: MANAGE_PASSWORD_CLEAR_STATE });
};

export const clearError = () => (dispatch) => {
  dispatch({ type: MANAGE_PASSWORD_CLEAR_ERROR });
};

export const resetPassword = (email) => async (dispatch) => {
  try {
    if (!isValidEmail(email)) {
      throw new ObjectException(
        {
          de: 'Email is not valid.',
          en: 'Email is not valid.',
          sv: 'Emailen är inte giltig.',
        },
        'INVALID_EMAIL'
      );
    }
    dispatch({ type: MANAGE_PASSWORD_REQUEST });
    await AuthService.resetPassword(email);
    dispatch({ type: MANAGE_PASSWORD_SUCCESS });
  } catch (ex) {
    logError(ex);
    dispatch({ type: MANAGE_PASSWORD_FAILURE, error: ex.message });
  }
};

export const submitPassword = (password, name, session, preventRedirect) => async (dispatch) => {
  try {
    dispatch({ type: MANAGE_PASSWORD_REQUEST });
    const { email } = await AuthService.setPassword({ password, name }, session);

    dispatch({ type: MANAGE_PASSWORD_SUCCESS });
    await dispatch(login(email, password, preventRedirect));
  } catch (ex) {
    logError(ex);
    dispatch({ type: MANAGE_PASSWORD_FAILURE, error: ex.message });
  }
};

export const updatePassword = (body) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_PASSWORD_REQUEST });
    await AuthService.updatePassword(body);
    dispatch({ type: UPDATE_PASSWORD_SUCCESS });
  } catch (ex) {
    logError(ex);
    dispatch({ type: UPDATE_PASSWORD_FAILURE, error: ex.message });
  }
};
